import Navigation from "./components/nav/Navigation";

export default function App() {
  return <Navigation />;
}
